import { LoadingContent } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/LoadingContent";
import { NoEventDataMessage } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/NoEventDataMessage";
import { ReactNode } from "react";
import { FailureMessageWithRetryButton } from "shared/components/feedback/FailureMessageWithRetryButton";
import { Flex, tokens } from "shared/components/Spor";
import { useTheme } from "styled-components";

type SectionStateContentProps = {
  isLoading: boolean;
  isError: boolean;
  isEmpty: boolean;
  onRetry: () => void;
  emptyContent?: ReactNode;
  children: ReactNode;
};

export const SectionStateContent = ({
  isLoading,
  isError,
  isEmpty,
  onRetry,
  emptyContent = <NoEventDataMessage />,
  children,
}: SectionStateContentProps) => {
  const theme = useTheme();

  if (isLoading) return <LoadingContent />;

  if (isError)
    return (
      <Flex
        flex="1"
        width="100%"
        alignItems="center"
        justifyContent="center"
        backgroundColor={theme.colorBackgroundMain}
        borderRadius="6px"
        px={tokens.default.size.spacing[3]}
      >
        <FailureMessageWithRetryButton retryFunction={onRetry} />
      </Flex>
    );

  if (isEmpty) return emptyContent;

  return children;
};
